<div class="status-line" *ngFor="let statement of statements">
  <i
    class="pi status-line__icon"
    [class.pi-check-circle]="statement.ok"
    [class.pi-exclamation-circle]="!statement.ok"
    [class.status-line__icon--ok]="statement.ok"
    [class.status-line__icon--problem]="!statement.ok"
  ></i>
  <span class="status-line__text">{{ statement.text }}</span>
</div>
